import { useIsMobile } from 'pricing-pages-ui-components/hooks/useMedia';
import { useIsFreePortal } from '../../../../v2/hooks/useProductInventory';
import { SingleSkeletonLoader } from '../../../components/SingleSkeletonLoader';
import { BrandingAndLimitPriorityFeatures } from '../../../components/merch-card/feature-display/BrandingAndLimitPriorityFeatures';
import { UncategorizedPriorityFeatures } from '../../../components/merch-card/feature-display/UncategorizedPriorityFeatures';
import { useHandleClickFreeToolsWithLimitsLink } from '../../../components/merch-card/feature-display/useHandleClickFreeToolsWithLimitsLink';
import { useCategorizedPriorityFeatures } from './useFeaturesDisplay';
import { isUngatedForInbound25Selector } from '../../../../selectors/GatingSelectors';
import { useAppSelector } from '../../../../reducers';
import { jsx as _jsx } from "react/jsx-runtime";
export const PriorityFeaturesByProductApiName = ({
  productApiName,
  lowerTierMessage
}) => {
  const isMobile = useIsMobile();
  const isUngatedForInbound25 = useAppSelector(isUngatedForInbound25Selector);
  const {
    isFreePortal,
    loading: isInventoryLoading
  } = useIsFreePortal();
  const {
    loading: isLoadingPriorityFeatures,
    brandingAndLimitFeatures,
    uncategorizedFeatures
  } = useCategorizedPriorityFeatures({
    productApiName
  });
  const loading = isInventoryLoading || isLoadingPriorityFeatures;
  const handleClickFreeToolsWithLimitsLink = useHandleClickFreeToolsWithLimitsLink();
  if (loading) {
    return /*#__PURE__*/_jsx(SingleSkeletonLoader, {
      height: 96,
      width: "100%"
    });
  }
  if (isUngatedForInbound25) {
    return /*#__PURE__*/_jsx(UncategorizedPriorityFeatures, {
      uncategorizedFeatures: uncategorizedFeatures,
      lowerTierMessage: lowerTierMessage,
      isCollapsible: isMobile
    });
  }
  if (brandingAndLimitFeatures.length) {
    return /*#__PURE__*/_jsx(BrandingAndLimitPriorityFeatures, {
      brandingAndLimitFeatures: brandingAndLimitFeatures,
      uncategorizedFeatures: uncategorizedFeatures,
      handleClickFreeToolsWithLimitsLink: handleClickFreeToolsWithLimitsLink,
      isCollapsible: isMobile,
      isFreePortal: isFreePortal
    });
  }
  if (uncategorizedFeatures.length) {
    return /*#__PURE__*/_jsx(UncategorizedPriorityFeatures, {
      uncategorizedFeatures: uncategorizedFeatures,
      lowerTierMessage: lowerTierMessage,
      isCollapsible: isMobile
    });
  }
  return null;
};